export function RectangleMinFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M4 6.667A2.667 2.667 0 016.667 4h10.666A2.667 2.667 0 0120 6.667v10.666A2.667 2.667 0 0117.333 20H6.667A2.667 2.667 0 014 17.333V6.667z"
      ></path>
    </svg>
  );
}
